module.exports = __webpack_public_path__ + "static/media/1861015.e866cb5a.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/elections/us/GeoData/1861015.geojson
// module id = 358
// module chunks = 0